import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ModelInput from './BatchEvaluation/ModelInput';
import { evaluateStart, updateInstanceSize } from '../../actions/EvaluationActions';
import DropDownList from '../../components/DropDownList';
import LineChart from '../../components/LineChart';

import './BatchEvaluation.sass';

class BatchEvaluation extends Component {
  constructor(props) {
    super(props);
    this.navigateBack = this.navigateBack.bind(this);
    this.handleStartEdgeMouseDown = this.handleStartEdgeMouseDown.bind(this);
    this.handleEndEdgeMouseDown = this.handleEndEdgeMouseDown.bind(this);
    this.handlePivotMouseDown = this.handlePivotMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleUpdateInstanceCategory = this.handleUpdateInstanceCategory.bind(this);
    this.handleUpdateInstanceSize = this.handleUpdateInstanceSize.bind(this);
    this.handleUpdateMetric = this.handleUpdateMetric.bind(this);
    this.handleStartEvaluation = this.handleStartEvaluation.bind(this);
    this.handleRedrawChart = this.handleRedrawChart.bind(this);

    this.state = {
      selectedRange: [10, 19],
      selectedPivot: 10,
      startEdgeDragging: false,
      endEdgeDragging: false,
      pivotDragging: false,

      instanceSizes: [
        { title: 'All', value: 'all' },
        { title: 'Large', value: 'l' },
        { title: 'Medium', value: 'm' },
        { title: 'Small', value: 's' }
      ],
      instanceCategories: [
        { title: 'people', value: 'people' }
        // { title: 'vehicle', value: 'vehicle' }
      ],
      metrics: [
        { title: 'Average Precision (AP)', value: 'ap' },
        { title: 'Average Recall (AR)', value: 'ar' },
        { title: 'Log-Average Miss Rate (LAMR)', value: 'lamr' }
      ],
      selected: {
        instanceSize: { title: 'All', value: 'all' },
        instanceCategory: { title: 'people', value: 'people' },
        metric: { title: 'Average Precision (AP)', value: 'ap' }
      }
    };
  }

  componentDidMount() {
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showAside !== this.props.showAside) {
      setTimeout(() => {
        this.PRCurve.redraw({ skipAnimation: true });
        this.MRFPPICurve.redraw({ skipAnimation: true });
      }, 500);
    }

    if (prevProps.evaluations.length + 1 === this.props.evaluations.length) {
      const { evaluations: e } = this.props;
      const { selectedPivot: p } = this.state;
      const {
        pr_curve: pr,
        mrfppi_curve: mrfppi,
        model: { color, name: title }
      } = e[e.length - 1];

      const prCurve = { title, color, value: pr[p] };
      const mrfppiCurve = { title, color, value: mrfppi[p] };

      this.PRCurve.appendLine(prCurve);
      this.MRFPPICurve.appendLine(mrfppiCurve);
      // console.log(data);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  navigateBack() {
    const { history } = this.props;
    const { search } = history.location;
    history.push(`/images/grid${search}`);
  }

  handleStartEdgeMouseDown() {
    this.setState({ startEdgeDragging: true });
  }

  handleEndEdgeMouseDown() {
    this.setState({ endEdgeDragging: true });
  }

  handlePivotMouseDown() {
    this.setState({ pivotDragging: true });
  }

  handleMouseUp() {
    this.setState({
      startEdgeDragging: false,
      endEdgeDragging: false,
      pivotDragging: false
    });
  }

  handleMouseMove(event) {
    const { startEdgeDragging, endEdgeDragging, pivotDragging } = this.state;
    const { legend: $legend } = this;
    const { pageX: mouseX } = event;

    if (startEdgeDragging) {
      const legendNodes = $legend.querySelectorAll('.legend-node');
      let pivoted = NaN;
      for (let i = 0; i < legendNodes.length; i += 1) {
        const node = legendNodes[i];
        const { x: nodeX } = node.getBoundingClientRect();

        if (mouseX < nodeX) {
          if (i === 0) {
            pivoted = 0;
            break;
          }
          const { x: previousNodeX } = legendNodes[i - 1].getBoundingClientRect();
          const deltaPrevious = mouseX - previousNodeX;
          const deltaNext = nodeX - mouseX;

          if (deltaPrevious < deltaNext) {
            pivoted = i - 1;
          } else {
            pivoted = i;
          }
          break;
        }
      }

      if (Number.isNaN(pivoted)) {
        pivoted = legendNodes.length - 1;
      }

      const endEdge = this.state.selectedRange[1];
      pivoted = pivoted < endEdge ? pivoted : endEdge - 1;
      this.setState({ selectedRange: [pivoted, this.state.selectedRange[1]] });
    } else if (endEdgeDragging) {
      const legendNodes = $legend.querySelectorAll('.legend-node');
      let pivoted = NaN;
      for (let i = 0; i < legendNodes.length; i += 1) {
        const node = legendNodes[i];
        const { x: nodeX } = node.getBoundingClientRect();

        if (mouseX < nodeX) {
          if (i === 0) {
            pivoted = 0;
            break;
          }
          const { x: previousNodeX } = legendNodes[i - 1].getBoundingClientRect();
          const deltaPrevious = mouseX - previousNodeX;
          const deltaNext = nodeX - mouseX;

          if (deltaPrevious < deltaNext) {
            pivoted = i - 1;
          } else {
            pivoted = i;
          }
          break;
        }
      }

      if (Number.isNaN(pivoted)) {
        pivoted = legendNodes.length - 1;
      }

      const startEdge = this.state.selectedRange[0];
      pivoted = pivoted > startEdge ? pivoted : startEdge + 1;
      this.setState({ selectedRange: [this.state.selectedRange[0], pivoted] });
    } else if (pivotDragging) {
      const legendNodes = $legend.querySelectorAll('.legend-node');
      let pivoted = NaN;
      for (let i = 0; i < legendNodes.length; i += 1) {
        const node = legendNodes[i];
        const { x: nodeX } = node.getBoundingClientRect();

        if (mouseX < nodeX) {
          if (i === 0) {
            pivoted = 0;
            break;
          }
          const { x: previousNodeX } = legendNodes[i - 1].getBoundingClientRect();
          const deltaPrevious = mouseX - previousNodeX;
          const deltaNext = nodeX - mouseX;

          if (deltaPrevious < deltaNext) {
            pivoted = i - 1;
          } else {
            pivoted = i;
          }
          break;
        }
      }

      if (Number.isNaN(pivoted)) {
        pivoted = legendNodes.length - 1;
      }

      this.setState({ selectedPivot: pivoted });
      this.handleRedrawChart();
    }
  }

  handleUpdateInstanceCategory(value) {
    const { selected } = this.state;
    this.setState({
      selected: { ...selected, instanceCategory: value }
    });
  }

  handleUpdateInstanceSize(value) {
    const { selected } = this.state;
    const { dispatch } = this.props;
    this.setState({
      selected: { ...selected, instanceSize: value }
    });
    dispatch(updateInstanceSize(value.value));
  }

  handleUpdateMetric(value) {
    const { selected } = this.state;
    this.setState({
      selected: { ...selected, metric: value }
    });
  }

  handleStartEvaluation() {
    const { dispatch } = this.props;
    dispatch(evaluateStart());
    this.PRCurve.clearLines();
    this.MRFPPICurve.clearLines();
  }

  handleRedrawChart() {
    this.PRCurve.clearLines();
    this.MRFPPICurve.clearLines();
    this.PRCurve.redraw();
    this.MRFPPICurve.redraw();

    const { evaluations: e } = this.props;
    const { selectedPivot: p } = this.state;

    e.forEach(({
      pr_curve: pr,
      mrfppi_curve: mrfppi,
      model: { color, name: title }
    }) => {
      const prCurve = { title, color, value: pr[p] };
      const mrfppiCurve = { title, color, value: mrfppi[p] };

      this.PRCurve.appendLine(prCurve);
      this.MRFPPICurve.appendLine(mrfppiCurve);
    });
  }

  renderNodeChart() {
    const {
      selected: { metric: { value } },
      selectedRange: range,
      selectedPivot: pivot
    } = this.state;
    const { evaluations } = this.props;

    const inRange = v => v >= range[0] && v <= range[1];

    let prop;
    if (value === 'ap') {
      prop = 'ap';
    } else if (value === 'ar') {
      prop = 'recall';
    } else if (value === 'lamr') {
      prop = 'lamr';
    }

    return evaluations.map(({ [prop]: metricValues, model: { name } }) => (
      <div
        className="row"
        key={name}
      >
        <span
          className="average-node"
          style={{ left: `${((range[0]) * 37.5) + 30}pt` }}
        >
          {((metricValues[range[0]] + metricValues[range[1]]) / 2).toFixed(3)}
        </span>
        <div className="nodes-wrapper">
          {
            metricValues.map((v, i) => (
              <span
                className={`
                  node
                  ${inRange(i) ? 'range-active' : ''}
                  ${i === pivot ? 'pivot-active' : ''}
                `}
                data-value={v.toFixed(3)}
                key={i}
              />
            ))
          }
        </div>
      </div>
    ));
  }

  render() {
    const {
      selectedRange: range,
      selectedPivot: pivot,
      // data,
      selected,
      instanceCategories,
      instanceSizes,
      metrics
    } = this.state;
    const { evaluations, evaluating } = this.props;
    const inRange = value => value >= range[0] && value <= range[1];

    const renderModelTitles = evaluations.map(({ model: { name, color } }) => (
      <p className="title" key={name}>
        <span className="color-palette" style={{ backgroundColor: color }} />
        {name}
      </p>
    ));

    return (
      <div className="BatchEvaluation" ref={(c) => { this.wrapper = c; }}>
        <div className="wrapper">
          <section className="evaluation-parameters">
            <h2>Evaluation Parameters</h2>

            <div className="input-field">
              <ModelInput />
            </div>

            <div className="evaluation-btn">
              <button
                onClick={this.handleStartEvaluation}
                disabled={evaluating}
              >
                {evaluating ? 'Evaluating' : 'Start Evaluation'}
              </button>
            </div>
          </section>

          <section className="evaluation-results">
            <h2>Evaluation Results</h2>

            <div className="result-wrapper">
              <div className="evaluation-filters">
                <DropDownList
                  title="Instance Categories"
                  options={instanceCategories}
                  selected={selected.instanceCategory}
                  width={100}
                  onSelect={this.handleUpdateInstanceCategory}
                />
                <DropDownList
                  title="Instance Size"
                  options={instanceSizes}
                  selected={selected.instanceSize}
                  width={100}
                  onSelect={this.handleUpdateInstanceSize}
                />
                <DropDownList
                  title="Focused Metric"
                  options={metrics}
                  selected={selected.metric}
                  width={200}
                  onSelect={this.handleUpdateMetric}
                />
              </div>

              <div className="node-chart">
                <div className="model-titles">
                  {
                    evaluations.map(({ model: { name, color } }) => (
                      <p className="title" key={name}>
                        <span className="color-palette" style={{ backgroundColor: color }} />
                        {name.substring(0, 10)}
                      </p>
                    ))
                  }

                  <p className="legend-title">IOU Rate</p>
                </div>

                <div className="model-rows" ref={(c) => { this.nodeChart = c; }}>
                  {
                    evaluations.length !== 0 && (
                      <div className="range-handler">
                        <div
                          className="start-edge"
                          style={{ left: `${((range[0]) * 37.5) + 30}pt` }}
                          onMouseDown={this.handleStartEdgeMouseDown}
                        >
                          <span className="draggable" ref={(c) => { this.startEdgeDragger = c; }} />
                          <span
                            className="handler-pillar"
                            style={{ height: `${((evaluations.length - 1) * 65) + 50}pt` }}
                          />
                        </div>
                        <div
                          className="end-edge"
                          style={{ left: `${((range[1]) * 37.5) + 30}pt` }}
                          onMouseDown={this.handleEndEdgeMouseDown}
                        >
                          <span className="draggable" ref={(c) => { this.endEdgeDragger = c; }} />
                          <span
                            className="handler-pillar"
                            style={{ height: `${((evaluations.length - 1) * 65) + 50}pt` }}
                          />
                        </div>
                      </div>
                    )
                  }

                  {
                    evaluations.length !== 0 && (
                      <div
                        className="pivot-handler"
                        style={{ left: `${((pivot) * 37.5) + 32}pt` }}
                      >
                        <span
                          className="draggable"
                          style={{ marginTop: `${(evaluations.length + 1) * 65}pt` }}
                          onMouseDown={this.handlePivotMouseDown}
                          ref={(c) => { this.pivotDragger = c; }}
                        />
                        <span
                          className="handler-pillar"
                          style={{ height: `${((evaluations.length - 1) * 65) + 50}pt` }}
                        />
                        <span className="pillar-node-wrapper">
                          {
                            evaluations.map((_, i) => (
                              <span
                                key={i}
                                className="pillar-node"
                              />
                            ))
                          }
                        </span>
                      </div>
                    )
                  }

                  {this.renderNodeChart()}
                  <div className="row" ref={(c) => { this.legend = c; }}>
                    <div className="nodes-wrapper legend-row">
                      {
                        Array.from(Array(20)).map((_, i) => (
                          <span
                            className={`
                              node legend-node
                              ${inRange(i) ? 'range-active' : ''}
                              ${i === pivot ? 'pivot-active' : ''}
                            `}
                            data-value={(i * 5) / 100}
                            data-index={i}
                            key={i}
                          />
                        ))
                      }
                    </div>
                  </div>

                  {/* <div className="legends">
                    {renderModelTitles}
                  </div> */}
                </div>
              </div>

              <div className="legends">
                {renderModelTitles}
              </div>


              <div className="line-charts">
                <div className="wrapper">
                  <h2>PR Curve</h2>
                  <LineChart
                    ref={(c) => { this.PRCurve = c; }}
                    xLabel="Recall"
                    yLabel="Precision"
                    xLabels={
                      Array.from(Array(10)).map((_, i) => (i + 1) / 10)
                    }
                    yLabels={
                      Array.from(Array(10)).map((_, i) => (i + 1) / 10)
                    }
                    intersection="0"
                    xRange={[0, 1]}
                    yRange={[0, 1]}
                  />
                </div>
                <div className="wrapper">
                  <h2>MR-FPPI Curve</h2>
                  <LineChart
                    ref={(c) => { this.MRFPPICurve = c; }}
                    xLabel="FPPI"
                    yLabel="MR"
                    xLabels={
                      Array.from(Array(10))
                        .map((_, i) =>
                          `10e${Math.floor((-4 + (((i + 1) / 10) * 6)) * 10) / 10}`
                        )
                    }
                    yLabels={
                      Array.from(Array(10))
                        .map((_, i) =>
                          `10e${Math.floor((-4 + (((i + 1) / 10) * 6)) * 10) / 10}`
                        )
                    }
                    xRange={[-4, 2]}
                    yRange={[-4, 2]}
                    intersection="10e-4"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

BatchEvaluation.propTypes = {
  history: PropTypes.object.isRequired,
  showAside: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  evaluating: PropTypes.bool.isRequired,
  evaluations: PropTypes.arrayOf(PropTypes.shape({
    ap: PropTypes.arrayOf(PropTypes.number).isRequired,
    lamr: PropTypes.arrayOf(PropTypes.number).isRequired,
    recall: PropTypes.arrayOf(PropTypes.number).isRequired,
    pr_curve: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))),
    interp_pr_curve: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))),
    mrfppi_curve: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)))
  })).isRequired
};

function mapStateToProps(store) {
  const { UI: { showAside }, Evaluation: { evaluations, evaluating } } = store;
  return { showAside, evaluations, evaluating };
}

export default withRouter(connect(mapStateToProps)(BatchEvaluation));



// WEBPACK FOOTER //
// ./src/containers/Main/BatchEvaluation.jsx